import { render, staticRenderFns } from "./BackgroundImage.vue?vue&type=template&id=5186eba6&scoped=true&"
import script from "./BackgroundImage.vue?vue&type=script&lang=js&"
export * from "./BackgroundImage.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundImage.vue?vue&type=style&index=0&id=5186eba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5186eba6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5186eba6')) {
      api.createRecord('5186eba6', component.options)
    } else {
      api.reload('5186eba6', component.options)
    }
    module.hot.accept("./BackgroundImage.vue?vue&type=template&id=5186eba6&scoped=true&", function () {
      api.rerender('5186eba6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/game/sunset-drive/components/BackgroundImage.vue"
export default component.exports